import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL, formatDate } from "../Helpers";
import { STR_BUY_NOW, STR_PURCHASE_SUBSCRIPTION_PACKAGE, STR_SUBSCRIPTION_HAS_EXPIRED } from "../Strings";
import { MdCall, MdMessage, MdWhatsapp } from "react-icons/md";

export default function View({ data }) {
	const appContext = useContext(AppContext);

	/* Place states here */


	function view() {
		appContext.navTo({
			item: "view",
			subItem: "message",
			extraItem: data.id,
		});
	}

	return (
		<div
			className=""
			onClick={view}
			style={{
				padding: "10px",
				paddingTop: "20px",
				paddingBottom: "20px",
				borderBottom: "1px solid var(--secondaryColor)",
			}}
		>
			<h6
				style={{
					fontSize: "16px",
				}}
				className="font-semi-bold"
			>
				{data.title}
			</h6>

			{
				(data.appType) ?
				<span className="badge bg-danger">{data.appType}</span>
				:""
			}

			<div className="text-end">
				<h6
					className="font-regular"
					style={{
						fontSize: "12px"
					}}
				>
					{formatDate(data.dateCreated)}
				</h6>
			</div>
		</div>
	);
}
